@if (tRows.length > 0) {
<div>
	<div class="task-statistics" [alarisLoading]="service.loading$">
		<div>
			<h6>{{ mdTask?.portedAmount }}</h6>
			<div>{{ 'manual_dipping.task.ported' | translate }}</div>
		</div>
		<div>
			<h6>{{ mdTask?.notPortedAmount }}</h6>
			<div>{{ 'manual_dipping.task.not_ported' | translate }}</div>
		</div>
	</div>

	@if (tRows.length > 0 || tRows.length === 0 && isFiltersApplied) {
	<div class="table-management">
		<div class="left">
			<span class="total">{{ 'gl.total' | translate }}: {{ total }}</span>
			<button (click)="editTableFilter()" alaris-button bType="outline" size="lg">
				<alaris-icon name="icon-filter-vertical"></alaris-icon>
				{{ 'gl.filter.filters' | translate }}
				@if (isFiltersApplied) {
				<div class="indicator"></div>
				}
			</button>
		</div>
		<div class="right">
			<button (click)="load()" alaris-button bType="outline" size="lg">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ 'actions.refresh_page' | translate }}
			</button>
			<button alarisButton [bType]="'primary'" size="lg" [ripple]="true" (click)="confirm()">
				{{ 'gl.export_results' | translate }}
				<alaris-icon name="icon-arrow-line-down"></alaris-icon>
			</button>
		</div>
	</div>
	}

	<alaris-table
		(filtersChange)="applyFilter($event)"
		(sortingChange)="applySorting($event)"
		[filters]="filters()"
		[fixFirstColumn]="false"
		[resizable]="false"
		[sorting]="sorting()"
		[tHeaders]="tHeaders()"
		[tRows]="tRows"
		class="alaris-table"
		[alarisLoading]="service.loading$"
		[templates]="{ported, number}"></alaris-table>

	<div class="footer">
		<alaris-pagination
			(page)="paginationChange($event)"
			[activePage]="activePage"
			[hidden]="total === 0"
			[pageSizeOptions]="pageSizeOptions"
			[pageSize]="pageSize"
			[total]="total"></alaris-pagination>
	</div>
</div>
} @else {
<div class="md-error">
	<alaris-alert [type]="'error'" [bg]="'typed'">
		<ng-container title>{{ 'manual_dipping.no_successful.title' | translate }}</ng-container>
		<ng-container>{{ 'manual_dipping.no_successful.subtitle' | translate }}</ng-container>
	</alaris-alert>
</div>
}

<ng-template #ported [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<alaris-icon [name]="data.ported !== 0 ? 'icon-success-_active' : 'icon-error'"></alaris-icon>
</ng-template>

<ng-template #number [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	{{ data.number | phoneNumber }}
</ng-template>
